import React from "react";
import { Styles } from "./styles";

const SwitchButton = ({ orderOption, setOrderOption }) => {
  const handleOptionChange = (option) => {
    setOrderOption(option);
  };

  return (
      <Styles orderOption={orderOption}>
        <div className="switch-container">
          <div
              className="all"
              onClick={() => handleOptionChange("all")}
          >
            All
          </div>
          <div
              className="service"
              onClick={() => handleOptionChange("service")}
          >
            Services
          </div>
          <div
              className="offer"
              onClick={() => handleOptionChange("offer")}
          >
            Offers
          </div>
        </div>
      </Styles>
  );
};

export default SwitchButton;